export const ORGANIZATION_PLAN_STATUS = {
  ACTIVE: 1,
  CANCELLED: 2,
  EXPIRED: 3,
  SUSPENDED: 4,
  DELETED: 5,
}
